import { render } from "./RepricedLocksDashboard.vue?vue&type=template&id=502045e2&scoped=true"
import script from "./RepricedLocksDashboard.vue?vue&type=script&lang=js"
export * from "./RepricedLocksDashboard.vue?vue&type=script&lang=js"

import "./RepricedLocksDashboard.vue?vue&type=style&index=0&id=502045e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502045e2"]])

export default __exports__